// DEV-ONLY (Juni 2026): B4 „Lernkontrolle" — 3 Entscheidungsvarianten zum Vergleich.
// KEINE /abo-Bühne. Reine Ansichtsseite, damit der Betreiber V1/V2/V3 groß im Browser
// sieht und EINE Variante auswählt. Bilder = echter Produkt-Screenshot (Erste Hilfe,
// Frage 1/4), lokal aufbereitet. Nach Entscheidung wird dieser Dev-View entfernt.

const V = [
  {
    id: "V1",
    title: "V1 · Handy im B3-Gerätelook",
    note: "Volles fotorealistisches iPhone wie in B3. Wiedererkennung, aber die Frage wird kleiner.",
    src: "/abo/_b4_variants/v1-device.webp",
    kind: "device",
  },
  {
    id: "V2",
    title: "V2 · Großer Screen, minimale Deko",
    note: "Nur der echte Screen mit dünnem Rahmen. Frage + Antworten deutlich größer als V1.",
    src: "/abo/_b4_variants/v2-screen.webp",
    kind: "screen",
  },
  {
    id: "V3",
    title: "V3 · Enger Crop: nur Frage + Antworten",
    note: "Kein Gerät, keine Ablenkung. Frage und Antwortmöglichkeiten riesig und glasklar.",
    src: "/abo/_b4_variants/v3-crop.webp",
    kind: "crop",
  },
];

export default function AboB4VariantsDev() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0f172a",
        color: "#e2e8f0",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        padding: "48px 24px 96px",
      }}
      data-testid="abo-b4-variants-dev"
    >
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <p
          style={{
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            fontSize: 12,
            color: "#38bdf8",
            fontWeight: 700,
            margin: 0,
          }}
        >
          B4 · Lernkontrolle · Entscheidungsvarianten
        </p>
        <h1 style={{ fontSize: 34, fontWeight: 800, margin: "10px 0 6px", color: "#f8fafc" }}>
          Welcher Look für den echten Frage-Screen?
        </h1>
        <p style={{ fontSize: 16, color: "#94a3b8", margin: "0 0 8px", maxWidth: 760 }}>
          Gleicher Produktzustand wie B3 („Erste Hilfe im Betrieb", Frage 1 von 4). Das sind
          drei <strong style={{ color: "#e2e8f0" }}>Entscheidungs</strong>varianten – nur EINE
          kommt später auf die Seite, nicht alle drei zusammen.
        </p>
        <p style={{ fontSize: 14, color: "#64748b", margin: "0 0 40px" }}>
          2-Sekunden-Test: Ein fremder Unternehmer muss sofort sehen „Nach der Unterweisung
          beantwortet mein Mitarbeiter Fragen." Copy (Headline + Chris) entscheiden wir danach.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: 32,
            alignItems: "start",
          }}
        >
          {V.map((v) => (
            <div
              key={v.id}
              data-testid={`b4-variant-${v.id}`}
              style={{
                background: "#1e293b",
                borderRadius: 20,
                padding: 24,
                border: "1px solid #334155",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 800,
                    color: "#0f172a",
                    background: "#38bdf8",
                    borderRadius: 999,
                    padding: "3px 10px",
                  }}
                >
                  {v.id}
                </span>
                <h2 style={{ fontSize: 17, fontWeight: 700, margin: 0, color: "#f1f5f9" }}>
                  {v.title.replace(/^V\d · /, "")}
                </h2>
              </div>
              <p style={{ fontSize: 13.5, color: "#94a3b8", margin: "10px 0 18px", minHeight: 54 }}>
                {v.note}
              </p>
              <div
                style={{
                  background:
                    v.kind === "device"
                      ? "linear-gradient(160deg,#e2e8f0,#cbd5e1)"
                      : "#f8fafc",
                  borderRadius: 16,
                  padding: v.kind === "crop" ? 0 : 18,
                  display: "flex",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <img
                  src={v.src}
                  alt={v.title}
                  loading="eager"
                  decoding="sync"
                  data-testid={`b4-variant-img-${v.id}`}
                  style={{
                    width: "100%",
                    maxWidth: v.kind === "device" ? 320 : "100%",
                    height: "auto",
                    display: "block",
                    borderRadius: v.kind === "crop" ? 16 : 0,
                    filter:
                      v.kind === "device"
                        ? "drop-shadow(0 24px 40px rgba(15,23,42,.35))"
                        : "none",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <p style={{ fontSize: 13, color: "#475569", marginTop: 48 }}>
          Dev-Vorschau · nicht Teil von /abo · wird nach der Variantenwahl entfernt.
        </p>
      </div>
    </div>
  );
}
